import React, { useEffect } from "react";
import { Box, CssBaseline } from "@mui/material"; // CssBaseline ayuda a estandarizar
import HomeAppBar from "./HomeAppBar";
import Footer from "../../../views/website/footer";

export function HomeLayout(props) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#FFF' }}>
            <CssBaseline />
            <HomeAppBar />
            
            {/* El pt (padding-top) debe ser igual o mayor a la altura del AppBar para que el contenido no quede oculto al inicio */}
            <Box component="main" sx={{ flexGrow: 1, pt: { xs: 8, md: 10 } }}>
                {props.children}
            </Box>
            
            <Footer />
        </Box>
    );
}